<template>
  <div class="box-type01">
    <div class="join-box">
      <i class="far fa-check-circle" aria-hidden="true"></i>
      <div class="entry-txt01 mgt30">
        <span>[{{props.mberNm}}]</span>님의 비밀번호가 변경되었습니다.</div>
      <div class="entry-txt02 mgt60">새로운 비밀번호로 안전하게 세로이 서비스를 이용해주세요.</div>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'로그인'"
         :color="'purple'"
         @click="btnLgin_click"/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits} from "vue";

const props = defineProps({
  mberNm: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['close']);
const btnLgin_click = () => {
  emits('close');
}
</script>

<style scoped>

</style>